import { CloseOverviewMember } from "@common/schemas/clientsCloseOverview.schema";

export function buildRolesByUserId(
    preparers: CloseOverviewMember[],
    reviewers: CloseOverviewMember[],
    managers: CloseOverviewMember[],
): Map<number, string[]> {
    const map = new Map<number, string[]>();
    const add = (m: CloseOverviewMember, label: string) => {
        const roles = map.get(m.userId) ?? [];
        if (!roles.includes(label)) {
            roles.push(label);
        }
        map.set(m.userId, roles);
    };
    preparers.forEach((m) => add(m, "Preparer"));
    reviewers.forEach((m) => add(m, "Reviewer"));
    managers.forEach((m) => add(m, "Manager"));
    return map;
}

export function deduplicateMembers(
    members: CloseOverviewMember[],
): CloseOverviewMember[] {
    return members.filter(
        (member, index, self) =>
            index === self.findIndex((t) => t.userId === member.userId),
    );
}
